var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImidM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 24,
    viewBox: "0 0 83 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4110_1982)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4110_1982",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.9789 0H0V24H81.9789V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4110_1982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.69788 6.84741H0.725076C0.324628 6.84741 0 7.17205 0 7.57249V23.2403C0 23.6406 0.324628 23.9653 0.725076 23.9653H2.69788C3.09833 23.9653 3.42296 23.6406 3.42296 23.2403V7.57249C3.42296 7.17205 3.09833 6.84741 2.69788 6.84741Z",
    fill: "#072F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69788 0.0366211H0.725076C0.324628 0.0366211 0 0.361249 0 0.761696V3.16956C0 3.57 0.324628 3.89462 0.725076 3.89462H2.69788C3.09833 3.89462 3.42296 3.57 3.42296 3.16956V0.761696C3.42296 0.361249 3.09833 0.0366211 2.69788 0.0366211Z",
    fill: "#072F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8765 6.40362C29.4959 6.40362 26.147 7.96101 24.8131 10.4776C23.5473 7.71027 21.7165 6.40362 18.5186 6.40362C15.9763 6.40362 13.286 7.49273 11.8237 9.45044L11.5639 7.47914C11.5171 7.11812 11.2089 6.84923 10.8449 6.84923H9.19381C8.79352 6.84923 8.46875 7.174 8.46875 7.57431V23.2419C8.46875 23.6423 8.79352 23.967 9.19381 23.967H11.0986C11.499 23.967 11.8237 23.6423 11.8237 23.2419V15.5788C11.8237 13.9716 13.0186 9.16343 18.5186 9.16343C24.0187 9.16343 23.2044 13.5713 23.2044 15.0653V23.2404C23.2044 23.6408 23.5291 23.9655 23.9294 23.9655H25.8342C26.2345 23.9655 26.5593 23.6408 26.5593 23.2404V15.6468C26.5593 10.8991 29.8827 9.16193 32.878 9.16193C36.3993 9.16193 37.2558 11.1483 37.2558 15.0637V23.2389C37.2558 23.6393 37.5805 23.964 37.9809 23.964H39.8857C40.286 23.964 40.6107 23.6393 40.6107 23.2389V15.2692C40.6107 12.8674 41.3403 6.4021 32.878 6.4021L32.8765 6.40362Z",
    fill: "#072F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9413 0.0366211H51.1877C51.6877 0.0366211 52.094 0.442965 52.094 0.942966V23.094C52.094 23.5941 51.6877 24.0004 51.1877 24.0004H46.9413C46.4415 24.0004 46.0352 23.5941 46.0352 23.094V0.942966C46.0352 0.442965 46.4415 0.0366211 46.9413 0.0366211Z",
    fill: "#7BE582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8649 16.932L68.9193 19.9153C68.5325 20.3066 67.9042 20.3081 67.5159 19.9215L62.5854 14.6103V7.31269L68.1973 13.3112L78.1655 3.21752C76.025 1.22205 73.1549 0 69.9993 0H58.4298C57.9298 0 57.5234 0.406344 57.5234 0.906345V23.0589C57.5234 23.559 57.9298 23.9653 58.4298 23.9653H69.9993C76.6171 23.9653 81.9811 18.6012 81.9811 11.9834C81.9811 10.4184 81.6776 8.92447 81.1323 7.55438L71.8649 16.9335V16.932Z",
    fill: "#7BE582"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4110_1982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.125,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImidM);
export default __webpack_public_path__ + "static/media/imid-m.e749e056dc7effd95ae243b4d674e335.svg";
export { ForwardRef as ReactComponent };